const network = require("./network");

/**
 * @typedef {Object} CountOptions
 * @property {String} kind the kind of object to count.
 * @private
 */

class CountManager {
    /**
     * POST a value on counter api.
     * @param {CountOptions} countOptions contain data to count
     */
    count(countOptions) {
        const url = `${woosmap.api_url}/counter/projects/${woosmap.public_key}/products/${this.STORES_PRODUCT}/kinds/${countOptions.kind}`;
        return network.post(url, countOptions).catch(() => {
            if (!(typeof console === "undefined" || typeof console.error === "undefined")) {
                console.error("Connection error with Counter");
            }
        });
    }
}

CountManager.prototype.STORES_PRODUCT = "STORES";

exports.CountManager = CountManager;
